import {
  consentManager,
  consentModel,
  consentTracker,
} from '@wetransfer/transfer/modules/consent-manager';
import Privacy from '@wetransfer/transfer/modules/privacy';
import ActionHelper from '@wetransfer/transfer/modules/redux-actions';

export const actions = ActionHelper.types([
  'SET_TRANSPARENCY_CONSENT_STRING',
  'SET_TRANSPARENCY_CONSENT_UI_VISIBLE',
]);

export default ActionHelper.generate({
  acceptAll(context, cookieWallVariant) {
    consentManager.acceptAll();
    consentTracker.acceptAll(context, cookieWallVariant);
    const tcString = consentModel.getTCString();

    // We're not using this to determine wallpaper provider but we are using
    // this to indirectly load SDKs for now.
    Privacy.acceptTrackers();

    return { type: actions.SET_TRANSPARENCY_CONSENT_STRING, tcString };
  },

  rejectAll(context, cookieWallVariant) {
    consentManager.rejectAll();
    consentTracker.rejectAll(context, cookieWallVariant);
    const tcString = consentModel.getTCString();

    Privacy.declineTrackers();

    return { type: actions.SET_TRANSPARENCY_CONSENT_STRING, tcString };
  },

  save(context, cookieWallVariant) {
    consentManager.save();
    consentTracker.save(context, cookieWallVariant);
    const tcString = consentModel.getTCString();

    // In the interest of time, if a does not give full consent, we treat this
    // as "rejected".
    if (!consentModel.hasFullConsent()) {
      Privacy.declineTrackers();
    }

    return { type: actions.SET_TRANSPARENCY_CONSENT_STRING, tcString };
  },

  setUIVisible(uiVisible) {
    return {
      type: actions.SET_TRANSPARENCY_CONSENT_UI_VISIBLE,
      uiVisible,
    };
  },
});
